import type { JSX } from "react";
import { Calendar } from "@repo/icons";
import { useAtom } from "jotai/index";
import {
  MessageDrawerActionButton,
  MessageDrawerActions,
  MessageDrawerBody,
  MessageDrawerRoot,
  MessageDrawerTitle,
} from "@/components/message-drawer";
import { appointmentFormAtom } from "@/lib/atoms/appointment-form-atom";

interface SchedulingInOtherLocationDrawerProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  submitAction: () => void;
}

export const SchedulingInOtherLocationDrawer = ({
  open,
  setOpen,
  submitAction,
}: SchedulingInOtherLocationDrawerProps): JSX.Element => {
  const [atomValues] = useAtom(appointmentFormAtom);
  const { unitName: locationName } = atomValues;

  return (
    <MessageDrawerRoot open={open} setOpen={setOpen} icon={Calendar} variant="secondary">
      <MessageDrawerTitle>
        Atenção: O horário selecionado é em uma{" "}
        <span className="font-bold">unidade diferente</span> da escolhida incialmente.
      </MessageDrawerTitle>
      <MessageDrawerBody>
        <p>Deseja seguir com esse agendamento na unidade {locationName}?</p>
      </MessageDrawerBody>
      <MessageDrawerActions>
        <MessageDrawerActionButton
          onClick={() => {
            submitAction();
          }}
          aria-label="continue to schedule button"
        >
          Continuar
        </MessageDrawerActionButton>
        <MessageDrawerActionButton
          onClick={() => {
            setOpen(false);
          }}
          aria-label="cancel schedule button"
          secondary
        >
          Cancelar
        </MessageDrawerActionButton>
      </MessageDrawerActions>
    </MessageDrawerRoot>
  );
};
